import { useEffect, useState } from 'react';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import rpcClient from 'ContentEditorUI/api/RpcClient';
import { getBrandAndSiteSettingsDiffsRpc, isPortalUngatedToMigrationRpc } from 'ContentEditorUI/__generated__/chirp/com/hubspot/branding/rpc/BrandAndSiteSettingsDiffRpc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEADLINE_DATE = new Date('2025-11-24');
const BrandMigrationAlert = () => {
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
    const checkForUnresolvedDiffs = async () => {
      // Diffs only need to be resolved while the portal has not opted in to the
      // branding migration. The REST endpoint gated on this and returned no
      // diffs once opted in; the RPC does not, so mirror that check here to
      // avoid re-showing the alert to already-migrated portals.
      const {
        isUngated
      } = await rpcClient.call(isPortalUngatedToMigrationRpc, {});
      if (isUngated) {
        return;
      }
      const response = await rpcClient.call(getBrandAndSiteSettingsDiffsRpc, {});
      const diffCount = Object.keys(response.logos).length + Object.keys(response.favicons).length;
      if (diffCount > 0) {
        setShowAlert(true);
      }
    };
    checkForUnresolvedDiffs().catch(error => {
      console.error(error);
    });
  }, []);
  const legacyBrandSettingsUrl = `${Routes.logoSettings('')}&resolveConflicts=true`;
  const date = /*#__PURE__*/_jsx(FormattedDateTime, {
    value: DEADLINE_DATE,
    format: "medium-full-date",
    type: "utc"
  });
  return showAlert ? /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    paddingInline: "500",
    paddingBlockStart: "400",
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "components.messages.brandMigrationAlert.title",
        options: {
          date
        }
      }),
      type: "warning",
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "components.messages.brandMigrationAlert.message",
          options: {
            date
          }
        }), /*#__PURE__*/_jsx(Button, {
          external: true,
          size: "sm",
          use: "primary",
          href: legacyBrandSettingsUrl,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "components.messages.brandMigrationAlert.reviewAndConfirm"
          })
        })]
      })
    })
  }) : null;
};
export default BrandMigrationAlert;